<div class="banner">
  <hyperkit-typography variant="h1" align="center" color="primary"
    >What's New</hyperkit-typography
  >
</div>
<div class="column-container" [ngClass]="{ 'small-screen': isSmallScreen }">
  <div class="version-container">
    @for (release of changelogs; track release) {
      <div class="link" [routerLink]="release.version">
        <hyperkit-link
          variant="emphasized"
          size="sm"
          align="left"
          text="{{ release.version }}"
        ></hyperkit-link>
      </div>
    }
  </div>
  <div class="releases-container">
    <router-outlet></router-outlet>
  </div>
</div>
